class FormActionsController {
  constructor() {
    this.name = 'formActions';
  }
}

export default FormActionsController;
